module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAVCAYAAAB2Wd+JAAABOUlEQVQ4jdWUvUoDURCFvzO5RiKKP2BskkIbHyC1D2OTB9GHs7IQLWzVgBYhqCAB3eyxyG5Ykt0ES6e6zJlzz8y5w9VwOLwEDoAHIFgfGbALDBLQt31VJAR4DbENTID3BIwk9Wz3bI82EPsR8Wl7koAWkCQ9Aa92My8ipsA+cFzOlAPbkpDURALolOOk5YKSWCo3XVbrYrW4qYMVxTpybeuNyIb4R8RGc/I8B/74HNXtsU3dNq0olkp1F1WVg/lSbwHfdaQl5WnZZSoOH8AAOJXkQuELmAKHQKvIdyU9Aj8J2LE9Bm4ldQBHhCWd2D6XdGc7t42kZ9tvwEV1xnEBEhFh+6yYy7ZHJbYwR1IXYDabLZJZluWS7oG9LMteqgYBRMRRknQDXEuaSCpRM/9fWpIyoF2oCQhJ6Rfkg4miQEoDcgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/手机.png
// module id = aj3z
// module chunks = 1